import { render, staticRenderFns } from "./CertifiedViaSupport.vue?vue&type=template&id=06c5e009&"
import script from "./CertifiedViaSupport.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CertifiedViaSupport.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports